// /**
//  * Parcel - Add
//  */

// React
import React, { useState, useEffect, useContext } from 'react';
// Context
import { Link } from 'react-router-dom';
import { handleErrorList } from '../../../../utils/helpers';
// react hook form
import { Controller, useForm } from 'react-hook-form';
import handleNotfication from '../../../../utils/handleNotfication';
// UI
import theme from '../../../../theme';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
  FormControlLabel,
  Checkbox,
  withStyles,
  Theme,
  Tooltip,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import GroupingErrorTable from '../../../../components/Table/groupingErrorTable';
import AddItemsParcelsForm from './addItemsParcelsForm';
import AddInventoryItemsParcelsForm from './addInventoryItemsParcelsForm';
import { CreateGroupingParcelsRequestBuilder } from 'client-sdk/src/parcels/parcels';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiArchiveOutline,
  mdiCubeOutline,
  mdiPaperclip,
  mdiPlusCircle,
  mdiCheckCircle,
  mdiAlertOctagonOutline,
  mdiInformationOutline
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses';

// Type
import {
  ParcelItems,
} from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
} from '../../../parcels/interfaces';
import { Warehouse } from '../../../warehouses/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour,
} from '../../../../utils/helpers';
import { Product } from '../../../products/interfaces';
import { Variant } from '../../../products/interfaces';
import { useHistory } from 'react-router-dom';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';
import classes from './add.module.scss';
import AuthContext from '../../../../authContext';
import enviroment from 'client-sdk/src/enviroments/enviroment';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

type Props = {
  create: (body: any) => void;
  onClose: () => void;
  warehouseId: number;
};

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  deliveryTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
  file: any;
  inboundType: "VIP" | "NORMAL"
};

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

type Data = { code: number; text: string; };
interface HeadCell {
  id: keyof Data;
  label: string;
}

const headCells: HeadCell[] = [
  {
    id: 'code',
    label: 'ردیف اکسل',
  },
  {
    id: 'text',
    label: 'توضیحات',
  },
];

const inboundItems = [
  {
    name: "shrink",
    label: "شیرینک",
    info: "در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند."
  },
  {
    name: "labelAttachment",
    label: "الصاق لیبل",
    info: "لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود."
  },
  {
    name: "modifyPackage",
    label: "تغییر در ساختار کالا",
    info: "در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید."
  },
  {
    name: "repackage",
    label: "تغییر بسته‌بندی",
    info: "در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغغیراتی در بسته‌بندی کالا ها اعمال شود."
  },
  {
    name: "kitting",
    label: "کیتینگ",
    info: "کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود."
  },
]

const QCItems = [
  {
    name: "checkItems",
    label: "بررسی تمام کالا‌ها",
    info: "با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند"
  },
  {
    name: "checkDate",
    label: "بررسی تاریخ تولید و انقضا",
  },
  {
    name: "test",
    label: "بررسی عملکرد کالا",
  },
  {
    name: "checkContents",
    label: "بررسی محتویات کارتن",
  },
  {
    name: "requestedQc",
    label: "کنترل کیفی درخواستی",
    info: "شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید"
  },
]

function GroupingCreateParcel(props: Props) {
  const token = localStorage.getItem('token') || '';
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors, control, watch, setValue, getValues } =
    useForm<Inputs>({
      defaultValues: {
        deliveryType: '',
        deliveryTime: '',
        deliveryDate: null,
        pickDate: null,
        pickTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
        file: null,
        inboundType: "NORMAL"
      },
    });

  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('BOX');
  const [transportationType, setTransportationType] = useState<any>('PARTNER');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] =
    React.useState(false);
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [destinationId, setDestinationId] = useState(enviroment.destinationId);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [tab, setTab] = useState(1)
  const [inboundDescription, setInboundDescription] = useState<string>("")
  const [qcDescription, setQcDescription] = useState<string>("")
  const [dimensions, setDimensions] = useState<any>([]);
  const [packageChoice, setPackageChoice] = useState<string[]>([])
  const [boxCount, setBoxCount] = useState('');
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 } as {
    lat: number;
    lng: number;
  });
  const [locationModal, setLocationModal] = useState(false);
  const [errorList, setErrorList] = useState<null | Error[]>(null);
  const [parcelParams, setParcelParams] = useState();
  const [file, setFile] = useState<any>('');
  const [count, setCount] = useState('');
  const [weight, setWeight] = useState('');
  const [size, setSize] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false)
  const loading = openAutocomplete && options.length === 0;
  const values = getValues();

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (values.inboundType == "VIP") {
      setPackageChoice([])
    }
  }, [values.inboundType])

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);
  const addDimensions = () => {
    const newDimension = {
      count,
      length: size,
      width: size,
      height: size,
      weight
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setSize('');
    setWeight('');
  };
  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);
  const checkButtonDisabled = () => {
    return !size || !weight || !count;
  };
  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    setDimensions([]);
  };
  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };
  const onSubmit = (data: Inputs) => {
    let {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      pickAddress,
      pickDate,
      pickTime,
      inboundType
    } = data;
    let ronadTransportationDTO, deliveryStartTime, deliveryEndTime;
    ronadTransportationDTO = {
      'ronadTransportationDTO.lat': latLng.lat,
      'ronadTransportationDTO.lon': latLng.lng,
      'ronadTransportationDTO.pickAddress': pickAddress,
      'ronadTransportationDTO.pickDate': pickDate ? pickDate : deliveryDate,
      'ronadTransportationDTO.pickTime': pickTime?.substring(0, 2).concat(':00:00'),
    };
    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
      deliveryStartTime = convertPersianDigit2English(
        pickTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        pickTime.substring(3, 5).concat(':00:00')
      )
    } else {
      deliveryStartTime = convertPersianDigit2English(
        pickTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        pickTime.substring(3, 5).concat(':00:00')
      )
    }
    let payload = new FormData();
    if (file) {
      payload.append('file', file[0]);
    }
    const params = {
      agentName,
      agentPhoneNumber,
      deliveryType,
      inboundType,
      // items,
      // partnerId: authContext?.user?.partnerId,
      deliveryDate,
      deliveryStartTime,
      deliveryEndTime,
      transportationType,
      ...ronadTransportationDTO,
      type: 'PARTNER',
      destinationId,
      // shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
    };
    addParcel(payload, params);
  };
  const addParcel = (body: any, params: any) => {
    setParcelsData(body);
    setParcelParams(params)
    handleOpenCheckConfirm();
  };
  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);

    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    if (hasExpirationDate) {
      setOpenAddInventoryItem(true);
    } else {
      setItems([
        ...items,
        {
          variantId,
          productId: idItem,
          count,
          packageCount: boxCount ?? 1,
          packageAmount: countOfBox ?? Number(count),
          inventoryItems: [
            {
              amount: Number(count),
              unitCost: unitCost ?? 0,
              productionDate: null,
              expirationDate: null,
            },
          ],
        },
      ]);
      setOpenAddItem(false);
    }
  };
  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setItems([...items, { ...item, inventoryItems: body }]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };
  const handleOpenCheckConfirm = () => {
    if (transportationType === 'PARTNER') {
      setCheckSubmit(true);
    } else {
      setOpenDimensions(true);
    }
  };
  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };
  const handleClose = () => {
    setOpenConfirmDelete(false);
    setCheckSubmit(false);
  };
  const deleteItemsToParcels = () => {
    const newValue = items.filter((item: any) =>
      item.variantId
        ? item.variantId !== itemDeleted.variant.id
        : item.productId !== itemDeleted.productId
    );
    const newValueInfo = itemsInfo.filter((item: any) =>
      item.variantId
        ? item.variantId !== itemDeleted.variant.id
        : item.productId !== itemDeleted.productId
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };
  const handleCreateParcel = async () => {
    setSubmitLoading(true)
    let payload = new FormData();
    payload.append('file', file);
    try {
      const makeRequest = new CreateGroupingParcelsRequestBuilder()
        .params(flattenObject(removeEmptyValueObject({
          ...parcelParams,
          'parcelPackages%5B0%5D.count': dimensions[0]?.count,
          'parcelPackages%5B0%5D.height': dimensions[0]?.height,
          'parcelPackages%5B0%5D.length': dimensions[0]?.length,
          'parcelPackages%5B0%5D.weight': dimensions[0]?.weight,
          'parcelPackages%5B0%5D.width': dimensions[0]?.width,
          'parcelCustomizedOperationDTO.checkContents': packageChoice.indexOf("checkContents") !== -1,
          'parcelCustomizedOperationDTO.checkDate': packageChoice.indexOf("checkDate") !== -1,
          'parcelCustomizedOperationDTO.checkItems': packageChoice.indexOf("checkItems") !== -1,
          'parcelCustomizedOperationDTO.kitting': packageChoice.indexOf("kitting") !== -1,
          'parcelCustomizedOperationDTO.labelAttachment': packageChoice.indexOf("labelAttachment") !== -1,
          'parcelCustomizedOperationDTO.modifyPackage': packageChoice.indexOf("modifyPackage") !== -1,
          'parcelCustomizedOperationDTO.repackage': packageChoice.indexOf("repackage") !== -1,
          'parcelCustomizedOperationDTO.requestedQc': packageChoice.indexOf("requestedQc") !== -1,
          'parcelCustomizedOperationDTO.shrink': packageChoice.indexOf("shrink") !== -1,
          'parcelCustomizedOperationDTO.test': packageChoice.indexOf("test") !== -1,
          'parcelCustomizedOperationDTO.inboundDescription': inboundDescription,
          'parcelCustomizedOperationDTO.qcDescription': qcDescription
        })))
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('محموله ها با موفقیت ایجاد شدند', 'success');
      history.push('/parcels-sender');
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }
      if (err?.response.status === 406) {
        // @ts-ignore
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        // @ts-ignore
        setErrorList(handleErrorList(err.response.data.errors));
      }
      if (
        err.response?.status == 406 &&
        err.response.data.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach(el => {
          handleNotfication(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          );
        });
      }
    } finally {
      setFile(null);
      setValue('file', null);
      setSubmitLoading(false)
    }
    handleCloseDimensions();
    setCheckSubmit(false);
  };
  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('deliveryTime', '');
  };
  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };
  const handlePickDateChange = (date: any) => {
    setValue(
      'pickDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  useOnMount(() => {
    register({ name: 'deliveryDate', type: 'text' });
    register({ name: 'pickDate', type: 'text', defaultValue: '' });
    register({ name: 'pickTime', type: 'text', defaultValue: '' });
  });

  const handleItemsChange = event => {
    const index = packageChoice.indexOf(event.target.name)
    if (index > -1) {
      const newChoises = [...packageChoice]
      newChoises.splice(index, 1)
      setPackageChoice(newChoises)
    } else {
      setPackageChoice([...packageChoice, event.target.name]);
    }
  };

  return (
    <>
            <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
              {`
        ایجاد گروهی محموله 
        `}
            </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
        <Typography className={classes.typographyCards}>
          اطلاعات محموله
        </Typography>
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="inboundType"
                    label="* نوع اینباند"
                    data-cy="inboundType"
                    as={
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        error={
                          !!errors.inboundType && !!errors.inboundType
                        }
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="end">
                      //       <Tooltip title="کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید">
                      //         <Icon
                      //           path={mdiInformationOutline}
                      //           size={1}
                      //           color={theme.palette.primary.main}
                      //           className={classes.icon}
                      //         />
                      //       </Tooltip>
                      //     </InputAdornment>
                      //   ),
                      // }}
                      >
                        <MenuItem
                          value="NORMAL"
                          data-cy="time1"
                        >
                          عادی
                        </MenuItem>
                        <MenuItem
                          value="VIP"
                          data-cy="time2"
                        >
                          ویژه
                        </MenuItem>
                      </TextField>
                    }
                  />
                </div>
                <FormHelperText error focused>
                  {errors?.inboundType &&
                    ' نوع اینباند الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="transportationTypeLabel">
                      * روش تحویل
                    </InputLabel>
                    <Select
                      label="* روش تحویل"
                      fullWidth
                      id="transportationType"
                      name="transportationType"
                      inputProps={{
                        name: 'transportationType',
                        id: 'transportationType',
                      }}
                      labelId="transportationTypeLabel"
                      value={transportationType}
                      onChange={e =>
                        setTransportationType(e.target.value)
                      }
                      inputRef={register({ required: true })}
                    >
                      <MenuItem value={'PARTNER'} data-cy="fromPartner">
                        ارسال توسط خودم
                      </MenuItem>
                      <MenuItem value={'RONAD'} data-cy="fromRonad">
                        جمع آوری توسط روناد
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <MuiPickersUtilsProvider
                    utils={JalaliUtils}
                    locale="fa"
                  >
                    <DatePicker
                      inputVariant="outlined"
                      id="deliveryDate"
                      name="deliveryDate"
                      label="* تاریخ تحویل محموله"
                      format="jYYYY/jMM/jDD"
                      minDate={disablePrevDateByHour(14)}
                      fullWidth
                      disablePast
                      autoOk
                      okLabel={null}
                      cancelLabel={null}
                      value={values.deliveryDate}
                      onChange={handleDeliveryDateChange}
                      error={errors.hasOwnProperty('deliveryDate')}
                    // helperText={
                    //   errors.deliveryDate && errors.deliveryDate.message
                    // }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <FormHelperText error focused>
                  {errors?.deliveryDate &&
                    'تاریخ تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  {transportationType === 'RONAD' ? (<Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="pickTime"
                    label={"* بازه تحویل به ناوگان"}
                    data-cy="pickTime"
                    as={
                      <TextField
                        variant="outlined"
                        select
                        fullWidth
                        error={
                          !!errors.pickTime && !!errors.pickTime
                        }
                      >
                        <MenuItem
                          disabled={checkHourisPast(
                            9,
                            values.deliveryDate
                          )}
                          value={'09-15'}
                          data-cy="time1"
                        >
                          {'9 الی 15'}
                        </MenuItem>
                        <MenuItem
                          disabled={checkHourisPast(
                            15,
                            values.deliveryDate
                          )}
                          value={'15-21'}
                          data-cy="time2"
                        >
                          {'15 الی 21'}
                        </MenuItem>
                      </TextField>
                    }
                  />) : (
                    <Controller
                      rules={{ required: true }}
                      style={{ width: '100%' }}
                      control={control}
                      name="pickTime"
                      label={"* بازه تحویل محموله"}
                      data-cy="pickTime"
                      as={
                        <TextField
                          variant="outlined"
                          select
                          fullWidth
                          error={
                            !!errors.pickTime && !!errors.pickTime
                          }
                        >
                          <MenuItem
                            disabled={checkHourisPast(
                              9,
                              values.deliveryDate
                            )}
                            value={'09-11'}
                            data-cy="time1"
                          >
                            {'9 الی 11'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              11,
                              values.deliveryDate
                            )}
                            value={'11-13'}
                            data-cy="time2"
                          >
                            {'11 الی 13'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'14-16'}
                            data-cy="time3"
                          >
                            {'14 الی 16'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'16-18'}
                            data-cy="time3"
                          >
                            {'16 الی 18 (ارسال خارج بازه)'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(
                              14,
                              values.deliveryDate
                            )}
                            value={'18-20'}
                            data-cy="time3"
                          >
                            {'18 الی 20 (ارسال خارج بازه)'}
                          </MenuItem>
                        </TextField>
                      }
                    />
                  )}
                </div>
                <FormHelperText error focused>
                  {errors?.pickTime &&
                    ' بازه تحویل محموله الزامی میباشد'}
                </FormHelperText>
              </Grid>
              {transportationType === 'RONAD' && <>
                <Grid item xs={9} alignItems="flex-end">
                  <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="pickAddress"
                        id="pickAddress"
                        label="آدرس جمع آوری"
                        inputRef={register({ required: false })}
                        error={errors.pickAddress && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Button
                      style={{ height: "56px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                      variant="outlined"
                      size="large"
                      component="span"
                      color="default"
                      onClick={() => setLocationModal(true)}>
                      {latLng.lat == 0 ? (<>
                        <span>اضافه کردن موقعیت مکانی</span>
                        <Icon
                          color={theme.palette.primary.main}
                          path={mdiPlusCircle}
                          size={1}
                          style={{ marginRight: "5px" }}
                        />
                      </>) : (
                        <>
                          <span>موقعیت شما با موفقیت ثبت شد</span>
                          <Icon
                            color={theme.palette.green.main}
                            path={mdiCheckCircle}
                            size={1}
                            style={{ marginRight: "5px" }}
                          />
                        </>
                      )}
                    </Button>
                  </div>
                </Grid>
              </>}
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="text"
                      id="agentName"
                      name="agentName"
                      label={transportationType === 'RONAD' ? "نام مسئول تحویل دهنده" : "نام مسئول حمل"}
                      inputRef={register({
                        required: false,
                      })}
                      error={errors.agentName && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {errors.agentName?.type === 'required' &&
                    'نام مسئول الزامی می باشد'}
                </FormHelperText>
              </Grid>
              <Grid item xs={3} sm={3} lg={3}>
                <div className={classes.item}>
                  <div style={{ width: '100%' }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="text"
                      id="agentPhoneNumber"
                      name="agentPhoneNumber"
                      label={transportationType === 'RONAD' ? "شماره مسئول تحویل دهنده" : "شماره مسئول حمل"}
                      inputRef={register({
                        required: false,
                        minLength: 11,
                        maxLength: 11,
                        pattern: /[0-9]/
                      })}
                      error={errors.agentPhoneNumber && true}
                    />
                  </div>
                </div>
                <FormHelperText error focused>
                  {(errors?.agentPhoneNumber?.type === 'minLength' ||
                    errors?.agentPhoneNumber?.type === 'maxLength') &&
                    'شماره همراه ۱۱ رقم میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'required' &&
                    'شماره‌ همراه مسئول حمل الزامی می باشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.agentPhoneNumber?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    inputRef={register({ required: false })}
                    name='description'
                    label="توضیحات"
                    data-cy="warehouseAddress"
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12}>
                <div className='notif' style={{marginTop: "8px"}}>
                <Icon
                  path={mdiAlertOctagonOutline}
                  size={1}
                />
                <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                  در اینباند ویژه کالاهای موجود در محموله حداکثر تا 3 ساعت کاری جای‌گذاری شده و با تعرفه ویژه محاسبه می‌شوند.
                </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Typography className={classes.typographyCards}>
          خدمات مازاد
        </Typography>
        <Card className={classes.card}>
          <CardContent style={{ padding: '0 0 12px 0' }}>
            <ul className={classes.tabContainer}>
              <li onClick={() => setTab(1)} className={classes.tabItems + " " + (tab == 1 && classes.active)}>اینباند</li>
              <li onClick={() => setTab(2)} className={classes.tabItems + " " + (tab == 2 && classes.active)}>کنترل کیفی</li>
            </ul>
            {tab == 1 && <Grid container justifyContent='space-between' style={{ marginTop: "70px" }}>
              {inboundItems.map(item => (
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleItemsChange}
                        checked={packageChoice.includes(item.name)}
                        name={item.name}
                        color="primary"
                        disabled={values.inboundType == "VIP"}
                        size='small'
                      />
                    }
                    label={
                      <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '400',
                            color: 'rgba(47, 72, 88, 1)',
                          }}
                        >
                          {item.label}
                        </Typography>
                        <HtmlTooltip title={item.info}>
                          <Icon
                            path={mdiInformationOutline}
                            size={.8}
                            color="#217AFF"
                            className={classes.icon}
                          />
                        </HtmlTooltip>
                      </div>
                    }
                  />
                </Grid>
              ))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name='inboundDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="inboundDescription"
                    value={inboundDescription}
                    onChange={e => setInboundDescription(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>}
            {tab == 2 && <Grid container justifyContent='space-between' style={{ marginTop: "70px" }}>
              {QCItems.map(item => (<Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleItemsChange}
                      checked={packageChoice.includes(item.name)}
                      name={item.name}
                      disabled={values.inboundType == "VIP"}
                      color="primary"
                      size='small'
                    />
                  }
                  label={
                    <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                      <Typography
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: 'rgba(47, 72, 88, 1)',
                        }}
                      >
                        {item.label}
                      </Typography>
                      {item.info && <HtmlTooltip title={item.info}>
                        <Icon
                          path={mdiInformationOutline}
                          size={.8}
                          color="#217AFF"
                          className={classes.icon}
                        />
                      </HtmlTooltip>}
                    </div>
                  }
                />
              </Grid>))}
              <Grid style={{ marginTop: "30px" }} item xs={12}>
                <div className={classes.item}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name='qcDescription'
                    placeholder="لطفا توضیحات مربوط به سرویس‌های انتخابی که می‌تواند در اجرای بهتر خدمات فوق کمک کند را وارد نمایید."
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    data-cy="qcDescription"
                    value={qcDescription}
                    onChange={e => setQcDescription(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>}
            <Grid container className='notif'>
              <Icon
                path={mdiAlertOctagonOutline}
                size={1}
              />
              <Typography style={{ marginRight: "10px", fontSize: "14px" }}>
                درخواست های مورد نظر بر روی تمامی کالاهای محموله اعمال می گردد.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        {authContext?.user?.partnerId == "14" && <>
          <Typography className={classes.typographyCards}>
            اطلاعات انبار مقصد
          </Typography>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Autocomplete
                      style={{ width: '100%' }}
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete(true);
                      }}
                      onClose={() => {
                        setOpenAutocomplete(false);
                      }}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      getOptionLabel={option => option.name}
                      options={options}
                      loading={loading}
                      onChange={(event: any, newValue: any | null) => {
                        setDestinationId(newValue?.id);
                        setValueWarehouse(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          variant="outlined"
                          {...params}
                          label="انبار مقصد"
                          inputRef={register({ required: false })}
                          name="admin"
                          id="admin"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress
                                    color="inherit"
                                    size={20}
                                  />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={9} sm={9} lg={9} spacing={2}>
                  <div className={classes.item}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      // defaultValue={' '}
                      value={valueWarehouse ? valueWarehouse?.address : ''}
                      label="آدرس انبار"
                      inputProps={{ readOnly: true }}
                      data-cy="warehouseAddress"
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>}
        <Typography className={classes.typographyCards}>
          بارگذاری فایل
        </Typography>
        <Card className={classes.card}>
          <CardContent style={{ paddingBottom: '10px' }}>
            <Grid container lg={12} md={12} className={classes.cardContent}>
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  padding: '0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <Grid container sm={5} md={5}>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'right',
                      textAlign: 'right',
                      marginBottom: '-10px',
                    }}
                  >
                    <Link
                      to="/prcelsample.xlsx"
                      style={{
                        color: '#DFA01F',
                        borderBottom: 'solid 1px #DFA01F',
                        paddingBottom: '3px',
                        textDecoration: 'none',
                      }}
                      target="_blank"
                    >
                      {'دریافت فایل نمونه'}
                    </Link>
                    <Link
                      to="/parcelsInstruction.xlsx"
                      style={{
                        paddingBottom: '3px',

                        color: '#2F4858',
                        marginLeft: '55px',
                        textDecoration: 'none',
                        borderBottom: 'solid 1px #2F4858',
                      }}
                      target="_blank"
                    >
                      {'دریافت فایل راهنما'}
                    </Link>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', width: '100%' }}>
                      <div className={classes.item}>
                        <label htmlFor="file" className={classes.labelInput}>
                          <Icon
                            color={'#666666'}
                            path={mdiPaperclip}
                            size={2}
                          />
                          <Typography>
                            {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                          </Typography>
                          <Typography
                            style={{
                              color: '#0375E8',
                              borderBottom: 'solid 1px #0375E8',
                            }}
                          >
                            انتخاب فایل از کامپیوتر
                          </Typography>

                          <input
                            id="file"
                            type="file"
                            name="file"
                            onChange={handleChangeFileInput}
                            ref={register({ required: true })}
                            multiple
                            className={classes.uploadInput}
                          />
                        </label>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {errorList && (
          <>
            <Typography className={classes.typographyCards}>
              لیست خطاها
            </Typography>
            <Card className={classes.card}>
              <CardContent style={{ paddingBottom: '10px', }}>
                <Grid container lg={12} md={12} style={{
                  justifyContent: 'space-between',
                  paddingLeft: '14px',
                }}>
                  <Grid container item xs={12} alignItems="flex-end">
                    <div className={classes.item}>
                      <>
                        <GroupingErrorTable data={errorList} headCells={headCells} />
                      </>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        )}
        <Grid
          container
          justifyContent='flex-end'
        >
          {/* <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
            >
              {'انصراف'}
            </Button> */}

          <Button
            type="submit"
            size="medium"
            data-cy="saveBtn"
            variant="contained"
            color="primary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                .length === 0
            }
          >
            {'ذخیره محموله '}
          </Button>
        </Grid>
      </form>
      <Dialog open={submitLoading} aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <Typography variant="h4" style={{ padding: '100px' }}>
            در حال ذخیره محموله
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="large"
                data-cy="cancelRemove"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
                data-cy="confirmRemove"
                color="primary"
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ایجاد محموله برای انبار "${checkSubmit ? valueWarehouse?.name : ''
              }" مطمئنید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
                data-cy="cancelCreateParcel"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
                data-cy="confirmCreateParcel"
                color="primary"
              >
                {'ذخیره محموله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDimensions}
        onClose={handleCloseDimensions}
        fullWidth
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                fullWidth
                id="count"
                name="count"
                value={count}
                onChange={e => setCount(e.target.value)}
                label="تعداد"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                fullWidth
                id="weight"
                name="weight"
                value={weight}
                onChange={e => setWeight(e.target.value)}
                label="وزن(گرم)"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                select
                fullWidth
                value={size}
                label="سایز بسته‌بندی"
                onChange={(e) => setSize(e.target.value)}
                error={
                  !!errors.pickTime && !!errors.pickTime
                }
              >
                <MenuItem
                  value={'10'}
                  data-cy="time1"
                >
                  کوچک
                </MenuItem>
                <MenuItem
                  value={'15'}
                  data-cy="time2"
                >
                  متوسط
                </MenuItem>
                <MenuItem
                  value={'20'}
                  data-cy="time3"
                >
                  بزرگ
                </MenuItem>
              </TextField>
            </Grid>
            {dimensions.length !== 0 && (
              <Grid item xs={12}>
                <ListDimensions data={dimensions} modal />
              </Grid>
            )}
          </Grid>
          {/* <Divider style={{ width: '100%', margin: '16px 0  0' }} /> */}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={6} style={{ marginRight: "auto", marginLeft: "8px" }}>
              <Button
                style={{ margin: '8px' }}
                autoFocus
                onClick={addDimensions}
                variant="outlined"
                color="primary"
                disabled={checkButtonDisabled()}
                size="large"
                data-cy="addBox"
              >
                اضافه کردن بسته
              </Button>
              <Button
                variant="contained"
                onClick={setUpdateStatus}
                size="large"
                data-cy="cancelAddProduct"
                color="primary"
                disabled={dimensions.length == 0}
              >
                ثبت نهایی
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />
      <Dialog
        maxWidth="md"
        open={locationModal}
        onClose={() => setLocationModal(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={() => setLocationModal(false)}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <MapPosition
            style={{ height: '400px', width: '500px' }}
            zoom={14}
            center={{ lat: 35.6892, lng: 51.389 }}
            position={latLng}
            setLatlng={(latLng: { lat: number; lng: number }) => {
              setLatLng(latLng);
            }}
          />
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ margin: '8px' }}
                onClick={() => setLocationModal(false)}
                variant="contained"
                color="primary"
                size="large"
                data-cy="cancelCreateParcel"
              >
                {'تایید'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

export default GroupingCreateParcel;


